import PiInstance from './Pi.instance';

export type PiUserUpdateRequestDataType = {
  userGuid: string;
  userEmail: string;
  firstName: string;
  lastName: string;
};

export const updateUserProfile = ({ companyGuid, data }: { companyGuid: string; data: PiUserUpdateRequestDataType }) =>
  PiInstance.instance.patch(`/user/api/v1/companies/${companyGuid}/users/${data.userGuid}/info`, data);
